import { render, staticRenderFns } from "./PatientSwitcher.vue?vue&type=template&id=22d163ea&"
import script from "./PatientSwitcher.vue?vue&type=script&lang=js&"
export * from "./PatientSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports